 <template>
  <v-dialog v-model="lessonPlan.dialog"
            width="840">
    <v-card class="blue-title">
      <v-card-title class="headline text-xs-center font-weight-bold blue-title">
        <v-spacer></v-spacer>
        Lesson Plan
        <v-spacer></v-spacer>
        <div class="header-close" title="close" @click="lessonPlan.dialog = false">
          <v-icon>close</v-icon>
        </div>
      </v-card-title>
      <v-card-text>
        <v-layout wrap>
            <v-flex class="text-xs-left"> 
                Class Time:{{lessonPlan.classTime | dateFileter('MM/DD/YYYY HH:mm')}}
            </v-flex>
            <v-flex class="text-xs-right">
                {{lessonPlan.classTime | formateWeek}}
            </v-flex>
        </v-layout>
        <v-form>
            <table>
                <tr>
                    <td rowspan="4" class="font-16">Student Details</td>
                    <td>
                        <span>Name:</span>
                        <span class="font-16">{{StudentDetail.Name}}</span>
                    </td>
                    <td>
                        <span>Gender:</span>
                        <span class="font-16">{{StudentDetail.Gender}}</span>
                    </td>
                    <td>
                        <span>Age:</span>
                        <span class="font-16">{{StudentDetail.Age}}</span>
                    </td>
                </tr>
                <tr>
                    <td>
                        <span>Hobbies:</span>
                        <span class="font-16 font-weight-bold" v-if="StudentDetail.Hobbies">
                            <template v-for="item in StudentDetail.Hobbies">
                                {{item}}、
                            </template>
                        </span>
                    </td>
                    <td colspan="2">
                        <span>Character:</span>
                        <span class="font-16 font-weight-bold" v-if="StudentDetail.Character">
                            <template v-for="item in StudentDetail.Character">
                                {{item}}、
                            </template>
                        </span>
                    </td>
                </tr>
                <tr>
                    <td colspan="3">
                        <span>English Level:</span>
                        <span class="font-16">{{StudentDetail.EnglishLevel}}</span>
                    </td>
                </tr>
                <tr>
                    <td colspan="3">
                        <span>Learning Goal：</span>
                        <span class="font-16">{{StudentDetail.LearningGoal}}</span>
                    </td>
                </tr>
                <tr>
                    <td class="font-16">Teacher Strategies</td>
                    <td colspan="3" class="pl-0">
                        <v-layout wrap>
                            <v-flex xs2 text-xs-right pr-2>
                                Lead-in
                            </v-flex>
                            <v-flex xs10>
                                <v-textarea 
                                    counter 
                                    single-line
                                    outline
                                    required
                                    placeholder="prior knowledge activation and rapport establishment based on the student’s hobbies and characteristics"
                                    :error-messages="$v.form.Leadin.$error ? !$v.form.Leadin.maxLength ? 'At most 1000 types': 'At least 100 types':''"
                                    @input="$v.form.Leadin.$touch()"
                                    v-model="form.Leadin"
                                    v-bind:disabled="diasabledInput"></v-textarea>
                            </v-flex>
                            <v-flex xs2 text-xs-right pr-2>
                                Highlight
                            </v-flex>
                            <v-flex xs10>
                                <v-textarea 
                                    counter 
                                    single-line
                                    outline
                                    required
                                    placeholder="dazzling the student with an engaging activity/game and creating a splendid and surprising moment in his/her mind by touching on the student’s hobbies and interests"
                                    :error-messages="$v.form.Highlight.$error ? !$v.form.Highlight.maxLength ? 'At most 1000 types': 'At least 100 types':''"
                                    @input="$v.form.Highlight.$touch()"
                                    v-model="form.Highlight"
                                    v-bind:disabled="diasabledInput"></v-textarea>
                            </v-flex>
                            <v-flex xs2 text-xs-right pr-2>
                                Happy Ending
                            </v-flex>
                            <v-flex xs10>
                                <v-textarea 
                                    counter 
                                    single-line
                                    outline
                                    required
                                    placeholder="utilizing one strategy that can reinforce the one-key takeaway and leave an ever-lasting moment in the student’s memory and empowering the student to share it with his/her parents"
                                    :error-messages="$v.form.HappyEnding.$error ? !$v.form.HappyEnding.maxLength ? 'At most 1000 types': 'At least 100 types':''"
                                    @input="$v.form.HappyEnding.$touch()"
                                    v-model="form.HappyEnding"
                                    v-bind:disabled="diasabledInput"></v-textarea>
                            </v-flex>
                        </v-layout>
                    </td>
                </tr>
                <tr>
                    <td class="font-16">Lesson Material</td>
                    <td colspan="3">
                        <span class="underline cursor-pointer font-16" v-if="!showLessonMaterial && lessonPlan.edit!='uneditable'" @click="showLessonMaterial=true">Click here for details</span>
                        <v-layout row wrap text-xs-left v-if="showLessonMaterial || lessonPlan.edit=='uneditable'">
                            <v-flex xs12 mb-2 v-if="LessonMaterial.Words">
                                <v-layout row wrap>
                                    <v-flex xs12>Word</v-flex>
                                    <v-flex xs12>
                                        <v-layout row wrap class="word-btn">
                                            <v-flex xs3 v-for="(item,i) in LessonMaterial.Words" :key="'word'+i"><span class="text-xs-center word-button mb-2">{{item}}</span></v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex xs12 v-if="LessonMaterial.Phonics">
                                <v-layout row wrap>
                                    <v-flex xs12>Phonics</v-flex>
                                    <v-flex xs12>
                                        <v-layout row wrap class="word-btn">
                                            <v-flex xs3 v-for="(item,i) in LessonMaterial.Phonics" :key="'phonics'+i"><span class="text-xs-center word-button mb-2">{{item}}</span></v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex xs12 v-if="LessonMaterial.Phrase">
                                <v-layout row wrap>
                                    <v-flex xs12>Phrase</v-flex>
                                    <v-flex xs12>
                                        <v-layout row wrap class="phrase-btn">
                                            <v-flex xs6 v-for="(item,i) in LessonMaterial.Phrase" :key="'phrase'+i" :class="(i+1)%2==0?'pl-3':'pr-3'"><span class="text-xs-center phrase-button mb-2">{{item}}</span></v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex xs12 v-if="LessonMaterial.Grammar">
                                <v-layout row wrap>
                                    <v-flex xs12>Grammar</v-flex>
                                    <v-flex xs12>
                                        <v-layout row wrap>
                                            <v-flex xs12 v-for="(item,i) in LessonMaterial.Grammar" :key="'grammar'+i"><span class="grammar-button mb-2 text-xs-left">{{item}}</span></v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex xs12 v-if="LessonMaterial.Keysentence">
                                <v-layout row wrap>
                                    <v-flex xs12>Key sentence</v-flex>
                                    <v-flex xs12>
                                        <v-layout row wrap>
                                            <v-flex xs12 v-for="(item,i) in LessonMaterial.Keysentence" :key="'keysentence'+i"><span class="grammar-button mb-2 text-xs-left">{{item}}</span></v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </td>
                </tr>
            </table>
        </v-form>
      </v-card-text>
      <v-card-actions class="pa-4" v-if="lessonPlan.classStatus!=='finished'&&lessonPlan.classStatus!=='incorrectFinished' && lessonPlan.edit!='uneditable'">
         <v-layout row>
            <v-flex xs12 class="text-xs-center">
              <v-btn class="text-none red-button dialog-submit"
                    :loading="submitting"
                    @click="submit">Submit</v-btn>
            </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { getLessonPlanInfo, saveLessonPlanInfo } from '@/api/classtable'
import vmodel from '@/mixins/v-model'
import { validationMixin } from 'vuelidate'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import dateFileter from '@/filters/dateFilter'
export default {
  name: 'lessonPlan',
  props: {
    lessonPlan: {
      dialog: false,
      clid:0,
      classStatus:"",
      classTime:"",
      edit:""
    }
  },
  mixins: [vmodel, validationMixin],
  data: () => ({
    form:{},
    submitting:false,
    showLessonMaterial:false,
    StudentDetail:{},
    LessonMaterial:{}
  }),
  validations() {
      return {
        form: {
          Leadin: { required, minLength: minLength(100),maxLength:maxLength(1000) },
          Highlight: { required, minLength: minLength(100),maxLength:maxLength(1000) },
          HappyEnding:{ required, minLength: minLength(100),maxLength:maxLength(1000) }
        }
      }
  },
  computed:{
    diasabledInput(){
        return this.lessonPlan.edit==="uneditable"?true:false
    }
  },
  mounted () {
    this.getPlanInfo()
  },
  methods: {
    getPlanInfo(){
        getLessonPlanInfo(this.lessonPlan.clid).then(res=>{
            if(res){
                this.StudentDetail = res.StudentDetail || {};
                this.form = res.TeacherStrategy || {};
                this.LessonMaterial = res.LessonMaterial || {};
            }
        })
    },
    submit(){
        this.$v.form.$touch();
        if (this.$v.form.$invalid) {
            console.log("form-error");
            this.submitting = false;
            return;
        }
        this.submitting = true
        let params = {
            clid:this.lessonPlan.clid,
            leadin:this.form.Leadin,
            highlight:this.form.Highlight,
            happyEnding:this.form.HappyEnding
        }
        saveLessonPlanInfo(params).then(res=>{
            if(res && res == 1){
                this.lessonPlan.dialog = false;
                // 在课表页填写备课信息提交成功后重新拉取数据
                if(this.$route.path=='/classTab'){
                    this.$store.dispatch('classTable/fetchData')
                }
            }else{
                this.$root.$alertTips('error', 'error')
            }
        }).finally(()=>{
            this.submitting = false
        })
    }
  },
  filters: { 
      dateFileter,
        formateWeek(time){
            let week = new Date(time).getDay();
            switch(week){
                case 0:
                    return 'Sunday'
                    break;
                case 1:
                    return 'Monday'
                    break;
                case 2:
                    return 'Tuesday'
                    break;
                case 3:
                    return 'Wednesday'
                    break;
                case 4:
                    return 'Thursday'
                    break;
                case 5:
                    return 'Friday'
                    break;
                case 6:
                    return 'Saturday'
                    break;
            }
        }
    }
}
</script>
<style lang="scss" scoped>
table{
    border-collapse:collapse;
    width: 100%;
    text-align: center;
    td{
        border: 1px solid #e3e3e3;
        padding: 18px;
        position:relative;
    }
    .font-16{
        font-size:16px;
    }
    tr:nth-child(1){
        td:nth-child(1){
            width:100px;
        }
    }
    tr:nth-child(1),tr:nth-child(2),tr:nth-child(3),tr:nth-child(4){
        >td{
            >span:nth-child(1){
                position: absolute;
                left: 5px;
                top: 2px;
            }
        }
    }
    .underline{
        text-decoration:underline;
    }
    .word-button,.phrase-button,.grammar-button{
        min-height:34px;
        border-radius:5px;
        background-color: #d7d7d7 !important;
        color:#32397A;
        display:inline-block;
        line-height:34px;
        padding:0 7px;
    }
    .word-button{
        min-width:115px;
    }
    .word-btn>.flex:nth-child(4n){
        text-align:right;
    }
    .word-btn>.flex:nth-child(4n-2),.word-btn>.flex:nth-child(4n-1){
        text-align:center;
    }
    .phrase-button,.grammar-button{
        width:100%;
    }
}
</style>
